/* oxlint-disable react/immutability */

import { type RowData } from '@tanstack/react-table';

import { useDataTableConfigElement } from '../../../hooks/useDataTableConfig.js';
import type { DataTableOptions } from '../types/table.types.js';

export function useLayout<TData extends RowData>(
  props: { fullWidth?: boolean; fullHeight?: boolean },
  options: DataTableOptions<TData>,
): void {
  const configFullWidth = useDataTableConfigElement('fullWidth');
  const configFullHeight = useDataTableConfigElement('fullHeight');

  options.layout = {
    ...options.layout,
    fullWidth: props.fullWidth ?? configFullWidth,
    fullHeight: props.fullHeight ?? configFullHeight,
  };
}
